import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ProvisioningService } from '../provisioned-devices/services/provisioning-service/provisioning-service';
import { DeviceProvisioningResponse } from '../provisioned-devices/models/device-provisioning-response.model';
import { TerminalComponent } from '../provisioned-devices/terminal/terminal.component';
import { Spinner } from '../../shared/components/spinner/spinner';

@Component({
  selector: 'app-terminal-page',
  standalone: true,
  imports: [CommonModule, FormsModule, TerminalComponent, Spinner],
  templateUrl: './terminal-page.component.html',
})
export class TerminalPageComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly provisioningService = inject(ProvisioningService);

  devices: DeviceProvisioningResponse[] = [];
  selectedClientId: string | null = null;
  isLoadingDevices = true;

  ngOnInit(): void {
    this.selectedClientId = this.route.snapshot.paramMap.get('clientId');

    this.provisioningService.getProvisionedDevices(0, 200, 'clientId', 'asc').subscribe({
      next: (res) => {
        this.devices = res.data;
        this.isLoadingDevices = false;
      },
      error: () => {
        this.isLoadingDevices = false;
      },
    });
  }

  onDeviceChange(clientId: string): void {
    const org = this.route.snapshot.parent?.paramMap.get('organizationName');
    this.router.navigate(clientId ? ['/', org, 'terminal', clientId] : ['/', org, 'terminal']);
    this.selectedClientId = clientId || null;
  }
}
